import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { FetchMovies, FetchTrendMovies, UpdateMovies } from "./ContentType";

export const fetchMovies = createAsyncThunk('content/fetchContentStatus', async (params: FetchMovies) => {
    const { type, minRating, sortingBy, ordering, search } = params;
    const response = await axios.get(`https://yts.mx/api/v2/list_movies.json?quality=${type}&limit=24&minimum_rating=${minRating}
    &page=1&sort_by=${sortingBy}&order_by=${ordering}&query_term=${search}`)
    return response.data.data;
}
)

export const fetchTrends = createAsyncThunk('content/fetchTrends', async () => {
    const response = await axios.get(`https://yts.mx/api/v2/list_movies.json?quality=2160p&limit=24&minimum_rating=5
    &page=1&sort_by=latest&order_by=desc`)
    return response.data.data;
}
)

export const fetchTrendMovies = createAsyncThunk('content/fetchTrendStatus', async (params: FetchTrendMovies) => {
    const { trendPage, search } = params;
    const response = await axios.get(`https://yts.mx/api/v2/list_movies.json?quality=2160p&limit=24&minimum_rating=5
    &page=${trendPage}&sort_by=latest&order_by=desc&query_term=${search}`)
    console.log(response)
    return response.data.data;
}
)

export const fetchUpdateMovies = createAsyncThunk('content/fetchContentUpdate', async (params: UpdateMovies) => {
    const { type, minRating, sortingBy, ordering, search, homePage } = params;
    const response = await axios.get(`https://yts.mx/api/v2/list_movies.json?quality=${type}&limit=24&minimum_rating=${minRating}
    &page=${homePage}&sort_by=${sortingBy}&order_by=${ordering}&query_term=${search}`)
    console.log(response)
    return response.data.data;
}
)
